import React, { useMemo } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ReceiptLong } from "@mui/icons-material";
import CustomDataGrid from "../../../../components/ui/customDataGrid/customDataGrid.component";
import { SETTLEMENT_EXTRA_POSITIONS_ENDPOINT } from "../../../../consts";
import { formatNumber } from "../../../../utils";
import {
  containsStringFilterOperators,
  equalsNumberFilterOperators,
} from "../../../../components/ui/customDataGrid/filterOperators";

export const SettlementExtraPositions = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: "id",
        headerName: "ID",
        filterOperators: equalsNumberFilterOperators(),
      },
      {
        field: "name",
        headerName: t("Name"),
        flex: 1,
        filterOperators: containsStringFilterOperators(),
      },
      {
        field: "price",
        headerName: t("Net price"),
        type: "number",
        filterOperators: equalsNumberFilterOperators(),
        valueFormatter: (value) => formatNumber(value),
      },
    ],
    [t]
  );

  const url = id
    ? `${SETTLEMENT_EXTRA_POSITIONS_ENDPOINT}?settlement=${id}`
    : SETTLEMENT_EXTRA_POSITIONS_ENDPOINT;

  return (
    <CustomDataGrid
      icon={<ReceiptLong />}
      title={t("Extra positions")}
      url={url}
      gridSettingsKey="SETTLEMENT_EXTRA_POSITIONS"
      columns={columns}
      refreshEventName="settlementUpdated"
    />
  );
};
